import type { SellerCommunicationStatus } from 'Pages/api/seller-communications/types';

export interface CreateLabelParams {
	failedToUpdateEnquiries: {
		enquiryId: string;
		saleId: string;
		status: SellerCommunicationStatus;
	}[];
	updatedEnquiryIds: string[];
}

export const createCtaLabel = ({ failedToUpdateEnquiries, updatedEnquiryIds }: CreateLabelParams) => {
	return JSON.stringify({
		failed: failedToUpdateEnquiries.map(({ enquiryId, status }) => {
			return {
				enquiryId,
				reason: status,
			};
		}),
		successful: updatedEnquiryIds,
	});
};
